import { Input as FpayInput } from 'fpay-ui';
import styled from 'styled-components';

const Input = styled(FpayInput)`
  margin-top: ${({ index }) => (index === 0 ? '0px' : '18px')};
`;

export default Input;
